import config from './Config';

import { GridDefinition } from 'Components/WorksheetGrids';
import { MoistureContentWetMassWorksheetGridControls } from './MoistureContentWetMassWorksheetGridControls';
import { MoistureContentWetMassWorksheetGridEntry } from './MoistureContentWetMassWorksheetGridEntry';

const MoistureContentWetMassWorksheetGridDefinition: GridDefinition = {
  worksheetType: 'Moisture Content Drying Tray',
  title: 'Moisture Content - Wet Mass Entry',
  shortTitle: 'Wet Mass Entry',
  query: {
    defaultParams: {
      IsReadyForBulkWetMassEntry: true,
      Limit: 300,
    },
    requiredParams: ['LaboratoryId', 'IsReadyForBulkWetMassEntry'],
  },
  controlsComponent: MoistureContentWetMassWorksheetGridControls,
  entryComponent: MoistureContentWetMassWorksheetGridEntry,
  config,
  commonDataSettings: {
    'MoistureContentTest.Oven': {
      onlyApplyOnChangesTo: ['data.DryingTray.WetSoilAndContainerMass'],
    },
    'DryingTray.DateTimePlacedInOvenLocal': {
      onlyApplyOnChangesTo: ['data.DryingTray.WetSoilAndContainerMass'],
    },
  },
  syncDialogSettings: {
    identifierPath: 'header.Sample.SampleId',
    identifierHeader: 'Sample Id',
    excludedPaths: ['MoistureContentTest.Balance', `MoistureContentTest.Oven`],
  },
};

export { MoistureContentWetMassWorksheetGridDefinition };
